<div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%" (click)="common.outSide($event)">
  <div class="header col-sm-12">
    <div class="col-sm-8">
      <h2> Liste des compte bancaires du client </h2>
    </div>
    <div class="col-sm-4 text-right">
      <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer</button>
      <button class="btn-header uppercase actionPricipal" id="valide" (click)="update()"> Valider</button>
      <!--div>
        <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
        <label class="text-left uppercase text-underline historique">Voir les documents</label>
      </div-->
    </div>
  </div>

  <div class="col-sm-12 ligneBon liste">
    <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listIbanBic || []"
                   [columnMode]="'force'" [headerHeight]="35"
                   [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
                   [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                   [loadingIndicator]="loadingIndicator" [selected]="selected">

      <ngx-datatable-column prop="banque">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Banque </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="codePays">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader"  (click)="sort()">
            <span class="uppercase"> Code pays </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="clefIBAN" prop="clefIBAN">
        <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                     let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Clef IBAN</span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="codeBanque" prop="codeBanque">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Code banque </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="codeGuichet">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Code guichet </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="numCompte" prop="numCompte">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Num. compte </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="clefRIB" prop="clefRIB">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase "> Clef RIB </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="BIC" prop="BIC">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> BIC </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="D" prop="D" [width]="60">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader">
            <span class="uppercase"> D </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div style="overflow: hidden;">
            <mat-checkbox class="example-margin" color="primary" [(ngModel)]="row.defaut" [disabled]="false">
            </mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false"
                            [draggable]="false" [resizeable]="false">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <div class="text-center">
            <button class="btn-detail" (click)="editRow(row); common.openModal(modalService, formEdit)">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn-detail" (click)="deleteLigne(row)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="addLigne col-sm-12 uppercase">
    <div class="col-sm-7 text-left">
      <button class="btn-add" id="addLigne" (click)="addEtInitialiserLigne()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="addEtInitialiserLigne()">Ajouter une ligne</span>

    </div>
    <label class="text-left uppercase text-underline historique col-sm-5"></label>
  </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<ng-template #formEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{selectedRow.id ? 'Modifier' : Nouveau}} IBAN+BIC : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="form-group items col-sm-12">
        <label class="col-sm-4 champ" style="padding:0px">
          Code Pays :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="codePays" [(ngModel)]="selectedRow.codePays"
          (ngModelChange)="onChangeCodePays()"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="5">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-4 champ" style="padding:0px">
          Clef IBAN :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="clefIBAN" [(ngModel)]="selectedRow.clefIBAN"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="2">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-4 champ" style="padding:0px">
          Banque :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="banque" placeholder="Banque" [(ngModel)]="selectedRow.banque"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="30">
        </div>
      </div>
      <div class="form-group items col-sm-12" *ngIf="!selectedRow.isCodePaysNonFr">
        <label class="col-sm-4 champ" style="padding:0px">
          Code Banque :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="codePays" [(ngModel)]="selectedRow.codeBanque"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="5">
        </div>
      </div>
      <div class="form-group items col-sm-12"  *ngIf="!selectedRow.isCodePaysNonFr">
        <label class="col-sm-4 champ" style="padding:0px">
          Code guichet :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="codeGuichet" [(ngModel)]="selectedRow.codeGuichet"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="5">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-4 champ" style="padding:0px">
          Num. compte :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="numCompte" [(ngModel)]="selectedRow.numCompte"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')">
        </div>
      </div>
      <div class="form-group items col-sm-12"  *ngIf="!selectedRow.isCodePaysNonFr">
        <label class="col-sm-4 champ" style="padding:0px">
          Clef RIB :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="clefRIB" [(ngModel)]="selectedRow.clefRIB"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="2">
        </div>
      </div>
  
      <div class="form-group items col-sm-12">
        <label class="col-sm-4 champ" style="padding:0px">
          BIC :
        </label>
        <div class="col-sm-8 champ" style="padding-right: 0px">
          <input type="text" class="form-control" id="BIC" [(ngModel)]="selectedRow.BIC"
                 autocomplete="off" (keydown.enter)="common.focusNext('.modalFicheClient')" maxlength="50">
        </div>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="verifIban();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer</button>
    </div>
  </div>
</ng-template>
